import type { ProjectLite } from "@/entities/project";
import type { UsersSelectOptionItem } from "@/modules/users/users-select";

import { useProjectsBatchAssign } from "@/entities/projects";
import { useBatchEditForm } from "@/modules/batch-edit-form";
import { getUsersSelectOptionItem } from "@/modules/users/users-select";

const fieldName = "users";

export const useProjectsBatchAssignUsers = (projects: ProjectLite[]) => {
  const initialValue = (projects[0]?.[fieldName] ?? []).map(
    getUsersSelectOptionItem
  );

  const ids = projects.map(({ id }) => id);
  const { mutate, isPending, status, error } = useProjectsBatchAssign(ids);

  const onMutateReady = (values: UsersSelectOptionItem[]) => {
    const users = values.map(({ value }) => value);
    return mutate(users);
  };

  const formProps = useBatchEditForm({
    fieldName,
    initialValue,
    onMutateReady,
    status,
    error,
  });

  return {
    ...formProps,
    fieldName,
    initialValue,
    isPending,
  };
};
